import React from 'react';
import { Grid, Typography, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PageTitle from '../../components/PageTitle/PageTitle';
import PriceTrend from '../../components/PriceTrend';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  introText: {
    marginBottom: theme.spacing(3),
  }
}));

const PriceTrendsPage = () => {
  const classes = useStyles();

  return (
    <>
      <PageTitle title="Price Trends Analysis" />
      <Paper className={classes.paper}>
        <Typography variant="body1" className={classes.introText}>
          Monitor daily price fluctuations from Joburg Market. This tool provides valuable insights 
          into market trends, helping farmers and agricultural businesses make informed decisions.
          Data is collected daily at 2 PM SAST directly from the Joburg Market website.
        </Typography>
      </Paper>
      
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <PriceTrend />
        </Grid>
      </Grid>
    </>
  );
};

export default PriceTrendsPage;
